export default class ContentTypeFieldListElement {
    constructor (dto) {
        this.id = 0;
        this.value = '';
        this.order = 0;

        if (dto) {
            this.id = dto.Id;
            this.value = dto.Value;
            this.version = dto.Order;
        }
    }

    toDto () {
        return {
            Id: this.id,
            Value: this.value,
            Order: this.order,
        };
    }
}
